"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.directMessages.loadFailed': '无法加载私信。',
    'whatsapp.directMessages.search': '搜索联系人...',
    'whatsapp.directMessages.contacts': '联系人',
    'whatsapp.directMessages.noContacts': '未找到私信联系人。',
    'whatsapp.directMessages.trackLogs': '跟踪日志',
    'whatsapp.directMessages.selectContact': '选择联系人以查看跟踪日志。',
    'whatsapp.directMessages.noLogs': '该联系人没有跟踪日志。',
    'whatsapp.directMessages.viewDetails': '查看详情',
};
